import { render, staticRenderFns } from "./InputImageUpload.vue?vue&type=template&id=6a90802a&scoped=true&"
import script from "./InputImageUpload.vue?vue&type=script&lang=js&"
export * from "./InputImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./InputImageUpload.vue?vue&type=style&index=0&id=6a90802a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a90802a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VFileInput,VImg})
